export default "__VITE_ASSET__DG5_3npw__"